import { Voiceover } from '../types'

// RFC-4180 quoting: wrap in quotes, double any inner quotes.
function csvCell (value: string): string {
  return `"${(value ?? '').replace(/"/g, '""')}"`
}

const HEADERS = ['Dateiname', 'POI', 'Abschnitt', 'Nugget', 'TextKey', 'Text']

export function buildVoiceoverCsv (rows: Voiceover[]): string {
  const lines = [HEADERS.map(csvCell).join(',')]
  rows.forEach((r) => {
    lines.push(
      [
        r.suggestedFileName,
        r.poiTitle,
        r.sectionTitle,
        r.nuggetTitle,
        r.textKey,
        r.text
      ]
        .map(csvCell)
        .join(',')
    )
  })
  // BOM so Excel reads UTF-8 (umlauts) correctly.
  return '﻿' + lines.join('\r\n')
}

export function downloadVoiceoverCsv (rows: Voiceover[], fileName: string): void {
  const blob = new Blob([buildVoiceoverCsv(rows)], {
    type: 'text/csv;charset=utf-8;'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
